import { initializeApp } from "firebase/app";
import { getFirestore, initializeFirestore  } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCMebX-6Mh2NxPHNOSPhAQ11Hq4xjy4pHE",
  authDomain: "mf-fire-maps-beta.firebaseapp.com",
  projectId: "mf-fire-maps-beta",
  storageBucket: "mf-fire-maps-beta.appspot.com",
  messagingSenderId: "1041577151528",
  appId: "1:1041577151528:web:a243a36c663f450504b91d",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app, "mf-fire");
const storage = getStorage(app);

export default {
  db,
  storage,
};
